import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values.dynamicAdminReviews && values.dynamicAdminReviews.length > 0) {
    const dynamicAdminReviewsErrors = [];
    values.dynamicAdminReviews.forEach((item, index) => {
      const itemErrors = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item.language || item.language.toString().trim() === '' || isLanguageInactive) {
        itemErrors.language = messages.required;
      }

      if (!item.userName) {
        itemErrors.userName = messages.required;
      } else if (item.userName.trim() == "") {
        itemErrors.userName = messages.required;
      } else if (item.userName && item?.userName?.length > inputTextLimit) {
        itemErrors.userName = messages.inputTextLimitError;
      }

      if (!item.reviewContent) {
        itemErrors.reviewContent = messages.required;
      } else if (item.reviewContent.trim() == "") {
        itemErrors.reviewContent = messages.required;
      } else if (item.reviewContent && item?.reviewContent?.length > inputDescLimit) {
        itemErrors.reviewContent = messages.inputDescLimitError;
      }

      if (Object.keys(itemErrors).length > 0) {
        dynamicAdminReviewsErrors[index] = itemErrors;
      }
    });

    if (dynamicAdminReviewsErrors.length > 0) {
      errors.dynamicAdminReviews = dynamicAdminReviewsErrors;
    }
  }

  return errors
}

export default validate;